module.exports = __webpack_public_path__ + "static/media/plug.26875e19.svg";